import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CustomBtn from "components/fragments/CustomBtn";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

export default function POSInUseWarningModal({
  modalOpenObj,
  selectedDevice,
  sessionStartData,
  isUserInImportantTask,
  onConfirm,
  ...props
}) {
  const navigate = useNavigate();
  const { businessSlug } = useParams();

  const hasImportantTask = isUserInImportantTask || false;

  const warningMessage = hasImportantTask
    ? "POS มีการใช้งานขายที่สำคัญอยู่อาจเกิดข้อผิดพลาดได้"
    : "POS มีการใช้งานอยู่อาจเกิดข้อผิดพลาดได้";

  const handleCancel = () => {
    modalOpenObj.setModalOpen(false);
  };

  const handleConfirm = async () => {
    localStorage.setItem("branchPOSId", selectedDevice?.id);
    modalOpenObj.setModalOpen(false);
    if (typeof onConfirm === "function") {
      onConfirm();
    } else {
      navigate(`/${businessSlug}/`);
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={handleCancel}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white w-[min(37.11vw,420px)] p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)]  text-[var(--color-black-2)] leading-[1.8] ">
            <div className="text-[#FF0000] text-[24px] font-bold mb-5">
              แจ้งเตือน !
            </div>
            <div className="text-[#FF0000] text-base font-[500]">
              {warningMessage}
            </div>
            <div className="leading-[2.2] font-[400] text-base text-[#061126] mb-4">
              คุณยืนยันการเข้าใช้งาน {selectedDevice?.deviceType}{" "}
              {selectedDevice?.posInfo?.posName} ใช่หรือไม่ ?
            </div>
            <hr />
            <div className="flex justify-center gap-[min(2.44vw,25px)] pt-3 mt-[min(0.98vw,10px)]">
              <CustomBtn
                onClick={handleCancel}
                className={`leading-[0.8] w-full text-[#6D788D] font-[600] min-h-[min(5.57vw,47px)] rounded-[min(0.78vw,8px)] btn-second-2-active text-18`}
                btntxt={"ยกเลิก"}
              />
              <CustomBtn
                onClick={handleConfirm}
                className={`leading-[0.8] w-full text-white font-[600] min-h-[min(5.57vw,47px)] rounded-[min(0.78vw,8px)] btn-main-active text-18`}
                btntxt={"ยืนยัน"}
              />
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
